import type {Margin} from '@yandex-delivery/blocks'
import {useContext, useEffect, useRef} from 'react'

import {Context} from './MarginContext'
import type {MarginContext, MarginRectFunction} from './types'

const useMarginContext = (): MarginContext => {
  const contextValue = useContext(Context)

  if (contextValue === null) {
    throw new Error('missing <MarginProvider />')
  }

  return contextValue
}

export const useMargin = (): Margin => useMarginContext()[0]

export const useMarginRef = <T extends Element>(getMarginRect: MarginRectFunction<T>) => {
  const [, strategyEffect] = useMarginContext()
  const ref = useRef<T>(null)
  const getMarginRectRef = useRef(getMarginRect)
  getMarginRectRef.current = getMarginRect

  useEffect(() => {
    return strategyEffect({
      strategy: () => {
        const element = ref.current

        if (!element) {
          return {}
        }

        return getMarginRectRef.current(element)
      },
    })
  }, [strategyEffect])

  return ref
}
